import { motion } from "framer-motion";

const stats = [
  { v: "4.9★", l: "Google Rating" },
  { v: "37+", l: "Five-Star Reviews" },
  { v: "9", l: "Signature Services" },
  { v: "100%", l: "Walk-Ins Welcome" },
];

export const Stats = () => {
  return (
    <section className="relative bg-[#0C120C] border-y border-barber-gold/15 radial-green overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 lg:grid-cols-4 gap-10">
        {stats.map((s, i) => (
          <motion.div
            key={i}
            data-testid={`stat-${i}`}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="text-center lg:text-left"
          >
            <div className="font-heading text-5xl sm:text-6xl font-bold text-barber-amber leading-none">
              {s.v}
            </div>
            <div className="mt-3 text-xs uppercase tracking-[0.25em] text-barber-muted">{s.l}</div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
